export const COLORS = [
    "#bf4330",
    "#43bf30",
    "#3069bf",
    "#bf7c30",
    "#30bfa3",
    "#8f30bf",
    "#bfb630",
    "#308fbf",
    "#bf3069",
];

export function indexToColor(i) {
    return COLORS[i] || "transparent";
}
